<template>
  <div>
    <el-form :inline="inline" :model="postForm" class="demo-form-inline">
      <el-form-item v-for="(item) in selects" :key="item.bindValue" :label="item.label || ''">
        <el-input v-if="item.type == 'input'" v-model="currentPostForm[item.bindValue]" :placeholder="item.placeholder || '请输入'" />
        <wq-select v-if="item.type == 'select'" :data-params="item.parmas" :columns="item.columns" :selected.sync="currentPostForm[item.bindValue]" :value-name="item.value || 'id'" :text-name="item.text || 'name'" :data-func="item.dataFunc" :placeholder="item.placeholder || '请选择'" />
        <el-date-picker v-if="item.type == 'daterange'" v-model="currentPostForm[item.bindValue]" value-format="yyyy-MM-dd" :picker-options="item.options" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="fnSetTime(item)" />
        <el-date-picker v-if="item.type == 'month'" v-model="currentPostForm[item.bindValue]" placeholder="选择月" value-format="yyyy-MM" type="month" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />

        <slot v-if="item.type == 'custom'" :currentForm="currentPostForm" :name="item.bindValue" :item="item" />
      </el-form-item>
      <el-button v-if="showSearch" type="primary" class="search-btn" @click="search()">搜索</el-button>
      <slot />
    </el-form>
  </div>
</template>

<script>

import WqSelect from '../FormBox/WqSelect'

export default {
  name: 'SelectBox',
  components: {
    WqSelect
  },
  props: {
    // [{type:'child_id',bindValue:'child_id'},{type:'shop_id',bindValue:'shop_id'}]
    selects: {
      type: Array,
      default() {
        return []
      }
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: true
    },
    postForm: {
      type: Object,
      default() {
        return { }
      }
    },
    rules: {
      type: Object,
      default() {
        return { }
      }
    }
  },
  data() {
    return {
      shopLists: [],
      currentPostForm: {}
    }
  },
  watch: {
    currentPostForm: {
      handler(newVal, oldVal) {
        this.$emit('update:postForm', newVal)
      },
      deep: true // 深度观察 obj 的变化
    }
  },
  created() {
    this.currentPostForm = Object.assign({}, this.postForm)
    this.fnGetSelectLists()
  },
  methods: {
    async fnGetSelectLists() {
      try {
        await Promise.all(this.selects.map(async(item, index) => {
          if (item.dataFunc) {
            const res = await item.dataFunc(item.parmas || {})
            console.log('aaaaaaaaaaaaa')
            console.log(res)
            this.shopLists = res.data
            console.log('shopLists')
            console.log(this.shopLists)
          }
          if (item.type === 'daterange') {
            this.currentPostForm[item.bindValue] = [this.currentPostForm[item.mapValue[0]], this.currentPostForm[item.mapValue[1]]]
          }
        }))
      } catch (error) {
        console.error(error)
      }
    },
    search() {
      this.$emit('search', this.currentPostForm)
    },
    fnSetTime(e) {
      if (this.currentPostForm[e.bindValue]) {
        this.currentPostForm[e.mapValue[0]] = this.currentPostForm[e.bindValue][0]
        this.currentPostForm[e.mapValue[1]] = this.currentPostForm[e.bindValue][1]
      } else {
        this.currentPostForm[e.mapValue[0]] = ''
        this.currentPostForm[e.mapValue[1]] = ''
      }
    }
  }
}
</script>

<style scoped>
    .search-btn {
       margin-bottom: 18px;
    }
    .el-form--inline .el-form-item {
      display: inline-block!important;
    }
</style>
